/**
 * DataElementsApi
 * DataElementsApi
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DataFieldDto } from './dataFieldDto';
import { DataTableDescriptionInfoDto } from './dataTableDescriptionInfoDto';
import { DataTableStatus } from './dataTableStatus';


export interface DataTableDto { 
    readonly organisation?: string;
    system?: string;
    systemInfo?: object;
    category?: string;
    tableName?: string;
    status?: DataTableStatus;
    clientSpecific?: string;
    languageDep?: string;
    businessObject?: string;
    lastChangedBy?: string;
    date?: string;
    time?: string;
    deliveryClass?: string;
    descriptionInfo?: DataTableDescriptionInfoDto;
    auth?: string;
    responsible?: string;
    tasks?: object;
    version?: string;
    wbs?: string;
    fields?: Array<DataFieldDto>;
}
export namespace DataTableDto {
}



export const DataTableDtoProps = {
  organisation: 'organisation',
  system: 'system',
  systemInfo: 'systemInfo',
  category: 'category',
  tableName: 'tableName',
  status: 'status',
  clientSpecific: 'clientSpecific',
  languageDep: 'languageDep',
  businessObject: 'businessObject',
  lastChangedBy: 'lastChangedBy',
  date: 'date',
  time: 'time',
  deliveryClass: 'deliveryClass',
  descriptionInfo: 'descriptionInfo',
  auth: 'auth',
  responsible: 'responsible',
  tasks: 'tasks',
  version: 'version',
  wbs: 'wbs',
  fields: 'fields',
} as const;

